import { render, staticRenderFns } from "./MoneyInputField.vue?vue&type=template&id=df8b2a58&scoped=true"
import script from "./MoneyInputField.vue?vue&type=script&lang=ts"
export * from "./MoneyInputField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df8b2a58",
  null
  
)

export default component.exports